const BASE = '/encurtador/v1';

async function req(metodo, caminho, body) {
  const resp = await fetch(`${BASE}${caminho}`, {
    method: metodo,
    credentials: 'include',
    headers: body ? { 'Content-Type': 'application/json' } : undefined,
    body: body ? JSON.stringify(body) : undefined,
  });
  if (resp.status === 204) return null;
  const contentType = resp.headers.get('Content-Type') || '';
  const data = contentType.includes('application/json') ? await resp.json() : null;
  if (!resp.ok) {
    const e = new Error(data?.mensagem || 'erro_requisicao');
    e.codigo = data?.erro || 'erro_requisicao';
    e.status = resp.status;
    throw e;
  }
  return data;
}

export const api = {
  me: () => req('GET', '/me'),
  perfilGet: () => req('GET', '/perfil'),
  perfilPut: (nome) => req('PUT', '/perfil', { nome }),
  linksListar: (cursor) => req('GET', `/links${cursor ? `?cursor=${encodeURIComponent(cursor)}` : ''}`),
  linksCriar: ({ nome, link, nome_personalizado }) => req('POST', '/links', { nome, link, nome_personalizado }),
  authCallback: (code, code_verifier) => req('POST', '/auth/callback', { code, code_verifier }),
  authRefresh: () => req('POST', '/auth/refresh'),
  authLogout: () => req('POST', '/auth/logout'),
};
